import IPUtility from "../classes/IPUtility";
import { IPAuditMember } from "./IPAuditMember";
import { IPCategory } from "./IPCategory";
import { IPConfiguration } from "./IPConfiguration";
import { IPContainer } from "./IPContainer";
import { IPContainerValue } from "./IPContainerValue";
import { IPItemReview } from "./IPItemReview";
import { IPManualPoint } from "./IPManualPoint";
import { IPSchedule } from "./IPSchedule";
import { KISAUser } from "./KISAUser";

export interface IPProject {
  // DB Fields
  uid: number; // 고유번호
  guid: string; // UUID
  factoryUID: number; // 사업장 고유번호
  name: string; // 대상공정명
  director: string; // 관할기관
  // processNames: string[]; // 공정명
  law1: string; // 관련법규
  law2: string; // 점검표 양식 규정
  help: string; // 도움말

  scheduleDepartments: string;
  scheduleContents: string;
  scheduleNotes: string;

  presentLevel: number; // 현재등급 인덱스
  goalLevel: number; // 목표등급 인덱스
  regionCode: number; // 지역 인덱스
  workersCount: number; // 근로자 수
  target: number; // 대상 구분 인덱스

  compareYear: number; // 비교연도
  hasCompare: boolean;
  isCompareYear: boolean;

  compareProjectUIDs: number[];

  isCompareByScore: boolean; // 점수에 의한 비교
  // isCompareByCount: boolean; // 건수에 의한 비교

  projectLeaderUID: number; // 프로젝트 리더 고유번호
  participantsUIDs: number[]; // 참여자들 고유번호
  noContentItemUIDs: number[]; // 미 포함 평가 항목들 고유번호

  manualPoints: string[]; // 수동 점수 배열

  isCompleted: boolean; // 작업 완료 여부 - //deprecated
  isNoPoint: boolean; // 점수 부여 여부 - true면 점수 표기를 안함
  isManualPoint: boolean; // 수동 점수 여부 - true면 수동으로 점수 기입
  isMinusContractor: boolean; // 도급업체 그래프 제외 여부 - //deprecated
  isDeleted: boolean; // 삭제 여부

  uploadedFileName: string; // 수동 업로드 파일

  startDate: Date | string; // 점검 시작일
  endDate: Date | string; // 점검 종료일

  entryDate: Date; // 생성일
  modifyDate: Date; // 마지막 수정일

  // Not DB
  factoryName: string; // 사업장명
  projectUserName: string; // 프로젝트 리더 이름
  participantsUsersName: string; // 참여자 명단
  processNamesSerial: string;

  manualPointsList: IPManualPoint[]; // 수동 점수
  schedules: IPSchedule[];
  auditMembers: IPAuditMember[]; // 감사팀
  meetingReviews: IPItemReview[]; // 면담사진
  evalReviews: IPItemReview[]; // 총평

  manualPointsValues: number[];
  projectUser: KISAUser; // 프로젝트 리더
  participantsUsers: KISAUser[]; // 참여자들
  categories: IPCategory[]; // 참여자 명단

  goalPoint: number; // 목표 점수
  averagePoint: number; // 평균 점수
  totalAssginedPoints: number; // 모든 할당 점수 // deprecated
  totalEvalPoints: number; // 모든 평가 점수  // deprecated
  totalConvertPoints: number; // 변환된 점수 // deprecated
  chartItemCount: number; // 그래프 아이템 개수 // deprecated
  chartItemCount2: number; // 그래프 아이템 개수 // deprecated

  uploadedFileBase64: string;
}

export const initializeIPProject: IPProject = {
  uid: 0, // 고유번호
  guid: "", // UUID
  factoryUID: 0, // 사업장 고유번호
  name: "", // 대상공정명
  director: "", // 관할기관
  // processNames: [] as string[], // 공정명
  law1: "산업안전보건법 제44조", // 관련법규
  law2: "제2020-55호와 KOSHA GUIDE P-105-2017", // 점검표 양식 규정
  help: "", // 도움말

  scheduleDepartments: "",
  scheduleContents: "이전 고용노동부 이행상태,\r\n보완결과 등 기존자료 검토,\r\nPSM 이행실태,\r\nPSM 기록관리,\r\n위험성평가 관리,\r\n안전운전계획 운영,\r\n비상조치계획 운영,\r\n면담,\r\n현장확인",
  scheduleNotes: "대회의실\r\n소회의실\r\n(면담: 공장장,\r\n부/과장,\r\n조/반장,\r\n현장작업자,\r\n정비보수작업자,\r\n도급업체작업자,\r\n\안전관리자)\r\n현장",

  presentLevel: 0, // 현재등급 인덱스
  goalLevel: 0, // 목표등급 인덱스
  regionCode: 0, // 지역 인덱스
  workersCount: 0, // 근로자 수
  target: 0, // 대상 구분 인덱스

  compareYear: 2018,
  hasCompare: false,
  isCompareYear: false,

  compareProjectUIDs: [] as number[],

  isCompareByScore: false, // 점수에 의한 비교
  // isCompareByCount: false, // 건수에 의한 비교

  projectLeaderUID: 0, // 프로젝트 리더 고유번호
  participantsUIDs: [] as number[], // 참여자들 고유번호
  noContentItemUIDs: [] as number[], // 미 포함 평가 항목들 고유번호

  manualPoints: [] as string[], // 수동 점수 배열

  isCompleted: false, // 작업 완료 여부
  isNoPoint: false, // 점수 부여 여부 - true면 점수 표기를 안함
  isManualPoint: true, // 수동 점수 여부 - true면 수동으로 점수 기입
  isMinusContractor: false, // 도급업체 그래프 제외 여부 - true면 보고서에 도급업체 그래프를 넣지 않음
  isDeleted: false, // 삭제 여부

  uploadedFileName: "",

  startDate: new Date(), // 점검 시작일
  endDate: new Date(), // 점검 종료일

  entryDate: new Date(), // 생성일
  modifyDate: new Date(), // 마지막 수정일

  // Not DB
  factoryName: "", // 사업장명
  participantsUsersName: "", //참여자 명단
  processNamesSerial: "", // 공정명

  schedules: [] as IPSchedule[],
  auditMembers: [] as IPAuditMember[],
  meetingReviews: [] as IPItemReview[],
  evalReviews: [] as IPItemReview[],

  manualPointsValues: [] as number[], // 수동 점수
  manualPointsList: [] as IPManualPoint[], // 수동 점수
  projectUser: {} as KISAUser, // 프로젝트 리더
  projectUserName: "", // 프로젝트 리더 이름
  participantsUsers: [] as KISAUser[], // 참여자들
  categories: [] as IPCategory[], // 참여자 명단
  totalAssginedPoints: 0, // 모든 할당 점수
  totalEvalPoints: 0, // 모든 평가 점수
  totalConvertPoints: 0, // 변환된 점수
  goalPoint: 0, // 목표 점수
  averagePoint: 0, // 평균 점수
  chartItemCount: 0, // 그래프 아이템 개수
  chartItemCount2: 0, // 그래프 아이템 개수

  uploadedFileBase64: "",
};

export const newIPProject = (): IPProject => {
  // const config = IPUtility.getConfiguration();
  // console.log("XXX");
  // console.log(config);

  const request = new XMLHttpRequest();
  request.open("GET", "/API/GetConfiguration", false); // `false` makes the request synchronous
  request.send(null);

  if (request.status === 200) {
    console.log(request.responseText);
    const parsed = JSON.parse(request.responseText);
    const config = parsed.item as IPConfiguration;
    return {
      uid: 0, // 고유번호
      guid: "", // UUID
      factoryUID: 0, // 사업장 고유번호
      name: "", // 대상공정명
      director: "", // 관할기관
      // processNames: [] as string[], // 공정명
      law1: config.law1, //"산업안전보건법 제44조", // 관련법규
      law2: config.law2, //"제2020-55호와 KOSHA GUIDE P-105-2017", // 점검표 양식 규정
      help: "", // 도움말

      scheduleDepartments: "",
      scheduleContents: "이전 고용노동부 이행상태,\r\n보완결과 등 기존자료 검토,\r\nPSM 이행실태,\r\nPSM 기록관리,\r\n위험성평가 관리,\r\n안전운전계획 운영,\r\n비상조치계획 운영,\r\n면담,\r\n현장확인",
      scheduleNotes: "대회의실\r\n소회의실\r\n(면담: 공장장,\r\n부/과장,\r\n조/반장,\r\n현장작업자,\r\n정비보수작업자,\r\n도급업체작업자,\r\n\안전관리자)\r\n현장",

      presentLevel: 0, // 현재등급 인덱스
      goalLevel: 0, // 목표등급 인덱스
      regionCode: 0, // 지역 인덱스
      workersCount: 0, // 근로자 수
      target: 0, // 대상 구분 인덱스

      compareYear: 2018,
      hasCompare: false,
      isCompareYear: false,

      compareProjectUIDs: [] as number[],

      isCompareByScore: false, // 점수에 의한 비교
      // isCompareByCount: false, // 건수에 의한 비교

      projectLeaderUID: 0, // 프로젝트 리더 고유번호
      participantsUIDs: [] as number[], // 참여자들 고유번호
      noContentItemUIDs: [] as number[], // 미 포함 평가 항목들 고유번호

      manualPoints: [] as string[], // 수동 점수 배열

      isCompleted: false, // 작업 완료 여부
      isNoPoint: false, // 점수 부여 여부 - true면 점수 표기를 안함
      isManualPoint: true, // 수동 점수 여부 - true면 수동으로 점수 기입
      isMinusContractor: false, // 도급업체 그래프 제외 여부 - true면 보고서에 도급업체 그래프를 넣지 않음
      isDeleted: false, // 삭제 여부

      uploadedFileName: "",

      startDate: new Date(), // 점검 시작일
      endDate: new Date(), // 점검 종료일

      entryDate: new Date(), // 생성일
      modifyDate: new Date(), // 마지막 수정일

      // Not DB
      factoryName: "", // 사업장명
      participantsUsersName: "", //참여자 명단
      processNamesSerial: "", // 공정명

      schedules: [] as IPSchedule[],
      auditMembers: [] as IPAuditMember[],
      meetingReviews: [] as IPItemReview[],
      evalReviews: [] as IPItemReview[],

      manualPointsValues: [] as number[], // 수동 점수
      manualPointsList: [] as IPManualPoint[], // 수동 점수
      projectUser: {} as KISAUser, // 프로젝트 리더
      projectUserName: "", // 프로젝트 리더 이름
      participantsUsers: [] as KISAUser[], // 참여자들
      categories: [] as IPCategory[], // 참여자 명단
      totalAssginedPoints: 0, // 모든 할당 점수
      totalEvalPoints: 0, // 모든 평가 점수
      totalConvertPoints: 0, // 변환된 점수
      goalPoint: 0, // 목표 점수
      averagePoint: 0, // 평균 점수
      chartItemCount: 0, // 그래프 아이템 개수
      chartItemCount2: 0, // 그래프 아이템 개수

      uploadedFileBase64: "",
    }
  }
  return { ...initializeIPProject };


}

export interface IPProjectListRequest {
  userToken: string; // 사용자 식별 값
  isAll: boolean; // isAll
  page?: number; // 페이지 번호 (옵션 : 기본값 1)
  rowCount?: number; // 한 페이지에 표시되는 개수 (옵션 : 기본값 30)
  searchWord?: string; // 검색어 (옵션)
  year?: number; // 연도
  grade?: number; // 등급
  region?: number; // 지역
}

export interface MyProjectRequest {
  userToken: string; // 사용자 식별 값
  id: number | null; // 프로젝트 고유번호 UID,
  successHandler?: any;
}
export interface getEditProjectRequest {
  userToken: string; // 사용자 식별 값
  id: number | null; // 프로젝트 고유번호 UID,
}
// note 2022-02-12 SmokingScully 추가
export interface deleteProjectRequest {
  userToken: string; // 사용자 식별 값
  id: number | null; // 프로젝트 고유번호 UID,
  successHandler?: any;
}
export interface createProjectRequest {
  userToken: string; // 사용자 식별 값
  item: IPProject; // 프로젝트 ,
  successHandler?: any;
}
export interface updateProjectRequest {
  userToken: string; // 사용자 식별 값
  item: IPProject; // 프로젝트 ,
  successHandler?: any;
}

export interface getQuotationRequest {
  userToken: string;
  searchWord: string;
  id: number;
  preYear: number;
  type: number;
}
export interface getfieldCheckListRequest {
  userToken: string;
  searchWord: string;
  // id: number;
}
export interface addCopiedCountRequest {
  userToken: string;
  id: number;
  type: number;
}
// note 2022-02-04 SmokingScully 추가
export interface updateContainerValueRequest {
  userToken: string;
  item: IPContainerValue;
  successHandler?: any;
}
// note 2022-02-04 SmokingScully 추가
export interface updateContainerRequest {
  userToken: string;
  projectUID: number;
  item: IPContainer;
  points: IPManualPoint[];
  noContentItemUIDs: number[];
  successHandler?: any;
  failHandler?: any;
  authFailHandler?: any;
}

export interface updateContainerAllRequest {
  userToken: string;
  projectUID: number;
  items: IPCategory[];
  points: IPManualPoint[];
  noContentItemUIDs: number[];
  successHandler?: any;
  failHandler?: any;
  authFailHandler?: any;
}
